const NAME_SPACE = 'HelpCenterArticlePage';

export { NAME_SPACE };
